<template>
  <div class="line-list">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LineList',
};
</script>

<style lang="scss" scoped>
.line-list {
  background: #fff;
  border-radius: 6px;
  padding: 5px;
  height: 40px;
  line-height: 30px;
  width: fit-content;
  display: flex;
  white-space: nowrap;

  > * {
    position: relative;
    display: inline-block;
    padding: 0 15px;

    &:not(:first-child):before {
      position: absolute;
      left: 0;
      display: inline-block;
      height: 20px;
      width: 2px;
      background: #ebf1f8;
      transform: translateY(6px);
      content: '';
    }
  }

  .anticon {
    font-size: 16px;
    padding-right: 5px;
  }
}
</style>
